import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../components/Icon";

export default function ConnectionStatusBar({ isConnected, isPolling, connectionFailed, isRecovering, phase }) {
    const { t } = useTranslation();
    const isActive = phase !== "url_input" && phase !== "complete";
    if (!isActive) return null;

    if (isRecovering) {
        return (
            <div className="flex items-center gap-2 px-4 py-2 bg-blue-50 border-b border-blue-200 text-blue-700 text-xs">
                <div className="w-3 h-3 border-2 border-blue-300 border-t-blue-600 rounded-full animate-spin" />
                <span className="font-medium">{t("builder.connection.recovering")}</span>
            </div>
        );
    }

    if (connectionFailed && !isPolling) {
        return (
            <div className="flex items-center gap-2 px-4 py-2 bg-red-50 border-b border-red-200 text-red-700 text-xs">
                <Icon name="WifiOff" className="w-3.5 h-3.5" />
                <span className="font-medium">{t("builder.connection.disconnected")}</span>
                <span className="text-red-500">{t("builder.connection.retrying")}</span>
            </div>
        );
    }

    if (isPolling) {
        return (
            <div className="flex items-center gap-2 px-4 py-2 bg-amber-50 border-b border-amber-200 text-amber-700 text-xs">
                <Icon name="RefreshCw" className="w-3.5 h-3.5 animate-spin" />
                <span className="font-medium">{t("builder.connection.polling")}</span>
            </div>
        );
    }

    return null;
}
